export const SEPARATION_REVIEW_PAGE_COPY = {
  confirmation_alert_title:
    "This is your last chance to review your payment info before submitting",
  confirmation_alert_body:
    "Please make sure all payees, amounts, and settings are correct.",
};
